// https://explorer.zksync.io/address/0x800813f4714BC7A0a95310e3fB9e4f18872CA92C
export const CROSS_CHAIN_CONTROLLER = '0x800813f4714BC7A0a95310e3fB9e4f18872CA92C';

// IPayloadsControllerCore https://explorer.zksync.io/address/0x2E79349c3F5e4751E87b966812C9E65E805996F1
export const PAYLOADS_CONTROLLER = '0x2E79349c3F5e4751E87b966812C9E65E805996F1';

// https://explorer.zksync.io/address/0xe28A3235DCF1Acb8397B546bd588bAAFD7081505
export const PC_DATA_HELPER = '0xe28A3235DCF1Acb8397B546bd588bAAFD7081505';

// https://explorer.zksync.io/address/0xe0e23196D42b54F262a3DE952e6B34B197D1A228
export const GRANULAR_GUARDIAN = '0xe0e23196D42b54F262a3DE952e6B34B197D1A228';

// https://explorer.zksync.io/address/0x4257bf0746D783f0D962913d7d8AFA408B62547E
export const GOVERNANCE_GUARDIAN = '0x4257bf0746D783f0D962913d7d8AFA408B62547E';

// https://explorer.zksync.io/address/0x04cE39789e11a49595cD0ECEf6f4Bd54ABF4d020
export const EXECUTOR_LVL_1 = '0x04cE39789e11a49595cD0ECEf6f4Bd54ABF4d020';

export const CHAIN_ID = 324;
